module.exports = __webpack_public_path__ + "static/scale-model-of-dark-hour-haunted-house-in-plano-texas-aad2de58db490baa2fc43e2df207d77c.png";